module.exports = __webpack_public_path__ + "static/media/12_l_kolona_0.31_7.87.8e29c538.png";